var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenless(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5222ff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152.631 -152.633)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.164,481.872a1.836,1.836,0,1,0-1.836-1.836A1.838,1.838,0,0,0,364.164,481.872Zm0-2.718a.882.882,0,1,1-.882.882A.883.883,0,0,1,364.164,479.154Z",
    transform: "translate(-181.533 -281.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M350.2,243.292H356.3a.477.477,0,0,0,0-.954H350.2a.477.477,0,0,0,0,.954Z",
    transform: "translate(-170.617 -77.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M203.888,161.485a.519.519,0,0,0-.043-.066.381.381,0,0,0-.066-.043,29.985,29.985,0,0,0-42.405,42.405.561.561,0,0,0,.043.066.382.382,0,0,0,.066.043,29.984,29.984,0,0,0,42.4-42.4Zm-21.257-7.9a28.941,28.941,0,0,1,20.184,8.188l-8.932,8.932v-5.941a1.264,1.264,0,0,0-1.263-1.262H172.643a1.263,1.263,0,0,0-1.262,1.262v28.444l-9.608,9.608a29.025,29.025,0,0,1,20.859-49.23Zm-10.3,40.017,20.593-20.595V200.5a.309.309,0,0,1-.309.308H172.643a.308.308,0,0,1-.308-.308Zm0-1.349v-27.49a.308.308,0,0,1,.308-.308h2.373v1.094a1.263,1.263,0,0,0,1.262,1.263h12.706a1.264,1.264,0,0,0,1.262-1.263v-1.094h2.372a.308.308,0,0,1,.309.308v6.9Zm16.958-27.8v1.094a.309.309,0,0,1-.308.309H176.279a.309.309,0,0,1-.308-.309v-1.094Zm-6.661,47.221a28.937,28.937,0,0,1-20.184-8.188l8.934-8.934V200.5a1.263,1.263,0,0,0,1.262,1.262H192.62a1.264,1.264,0,0,0,1.263-1.262V172.055l9.607-9.607a29.025,29.025,0,0,1-20.859,49.23Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenless);
export default __webpack_public_path__ + "static/media/Screenless.daaff71f323b93e2ab37534bab3085cc.svg";
export { ForwardRef as ReactComponent };